import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from "@ngx-translate/core";
import * as stripJsonComments from 'strip-json-comments';
import { Helper } from './helper';

export class TranslateHttpLoaderJSONC implements TranslateLoader {
  // djb:note-set defaults in definition rather than caller
  private prefix = '/Fastco/js/ngHome/assets/i18n/';
  private suffix = '.jsonc';
  // djb:debug-to isolate singleton service issues
  public id: string;

  constructor(
    private http: HttpClient
  ) {
    this.id = Helper.generateId(1);
    Helper.log(`translate.constructor id:${this.id}`);
  }

  getTranslation(lang: string) {
    const file = this.prefix + lang + this.suffix;
    Helper.log(`TranslateLoaderJSONC: id:${this.id} file:${file}`);
    return this.http.get(file, { responseType: 'text' }).map(jsonc => JSON.parse(stripJsonComments(jsonc)));
  }
}
